import intl from 'react-intl-universal';
import { useState } from 'react';
import { MultiButtonModal } from 'shared/modals/MultiButtonModal/multiButtonModal';
import PropTypes from 'prop-types';
import { zIndexValues } from 'utils/styles';
import { Typography, Input } from '@mui/material';

const propTypes = {
  isOpened: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  bodyText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  cancelButtonColor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  confirmButtonIsLoadingButton: PropTypes.bool,
  confirmButtonIsLoading: PropTypes.bool,
};

const CONFIRMATION_TEXT = 'confirm';

const ConfirmModalWithConsent = ({
  isOpened,
  onCancel = () => {},
  onConfirm = () => {},
  title,
  bodyText,
  confirmButtonText,
  cancelButtonText,
  confirmButtonColor,
  cancelButtonColor,
  confirmButtonIsLoadingButton = false, // normal button by default;
  confirmButtonIsLoading = false, // the loading button is not in loading status by default;
  children,
}) => {
  const [inputValue, setInputValue] = useState('');

  const buttons = [];

  const handleCancel = () => {
    setInputValue('');
    onCancel();
  };

  const handleConfirm = () => {
    setInputValue('');
    onConfirm();
  };

  buttons.push({
    // by default, this is the confirm / yes button
    dataTestId: 'confirm-modal-button-yes',
    label: confirmButtonText ?? intl.get('') ?? '',
    variant: confirmButtonColor ?? 'info',
    onClick: handleConfirm,
    isLoadingButton: confirmButtonIsLoadingButton,
    isLoading: confirmButtonIsLoading,
    isDisabled: inputValue !== CONFIRMATION_TEXT,
  });
  if (cancelButtonText) {
    buttons.push({
      dataTestId: 'confirm-modal-button-cancel',
      label: cancelButtonText ?? intl.get('') ?? '',
      variant: cancelButtonColor ?? 'error',
      close: true, // this is the cancel / no button
    });
  }

  return (
    <MultiButtonModal
      title={title}
      bodyText={bodyText}
      isOpened={isOpened}
      onClose={onCancel ? handleCancel : handleConfirm}
      zIndex={zIndexValues.modal5}
      actionButtons={buttons}>
      {children}
      <Typography
        sx={{
          paddingBottom: '10px',
          lineHeight: 1.5,
          fontSize: '16px',
          color: 'rgba(0, 0, 0, 0.7)',
        }}>
        {intl.get('modal_delete_consent_message')}
        <strong
          style={{
            marginTop: '5px',
            display: 'block',
            textAlign: 'center',
            color: 'rgba(0, 0, 0, 0.87)',
          }}>
          {CONFIRMATION_TEXT}
        </strong>
      </Typography>
      <Input
        fullWidth
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={`${CONFIRMATION_TEXT}`}
      />
    </MultiButtonModal>
  );
};

ConfirmModalWithConsent.propTypes = propTypes;

export default ConfirmModalWithConsent;
